import { render } from "./B2CConfirmEmailTokenHeroTile.vue?vue&type=template&id=99beaf06&ts=true"
import script from "./B2CConfirmEmailTokenHeroTile.vue?vue&type=script&lang=ts"
export * from "./B2CConfirmEmailTokenHeroTile.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__